
<app-system-message
[severity]="1"
[icon]="'#sx-info'"
[isVisible]="true"
[isDismissable]="false"
[type]="3">
{{ displayText }}
</app-system-message>